'use client';

import FetchUtils from '@dr-pam/common-components/Utils/FetchUtils';
import useAbortRegistry from '@dr-pam/common-components/Hooks/useAbortRegistry';
import { useMemo } from 'react';
import type { RegisterAbortFunction } from '@dr-pam/common-components/Utils/AbortUtils';

export type IpInfoResponse = {
	city: string;
	region: string;
	country: string;
};

export default class ClientUserIpInfoService {
	constructor(private readonly _registerAbort?: RegisterAbortFunction) {}

	public async getUserIpInfo() {
		const request = FetchUtils.getJson<IpInfoResponse>('https://ipinfo.io/json');
		return FetchUtils.abortableRequest(request, this._registerAbort);
	}
}

export const useClientUserIpInfoService = () => {
	const registerAbort = useAbortRegistry();

	return useMemo(() => new ClientUserIpInfoService(registerAbort), [registerAbort]);
};
